import gql from 'graphql-tag'

const SUBMIT_ANSWERS = gql`
  mutation submitAnswers($request: SubmitAnswersInput!) {
    submitAnswers(questionsAndAnswers: $request)
  }
`
//status matching backend
export const TEMPLATE_STATUS = {
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  COMPLETE: 'Complete',
}

export default SUBMIT_ANSWERS
